import * as React from 'react';
import { QueryCondition, User, Query, QueryFilter } from '../misc/api/apiTypes';
import { useWebPortalLegacyClient } from '../misc/api/WebPortalTokenClient';
import MultiSelectModal from '../misc/components/queryTable/MultiSelectModal';

const UserNameKey = "Username";
const UserFilterQueryCondition = QueryCondition.Equal;
export const UserHeader = "User";

interface UserFilterProps {
    filterMember: string;
    onApply: (member: string, condition: QueryCondition, values: string[]) => void;
    onClose: () => void;
    query: Query<User>;
}

const UserFilterModal = ({ filterMember, onClose, onApply, query }: UserFilterProps): JSX.Element => {

    const GetQueryFilter = (query: Query<User>): QueryFilter => {
        return query.Filters.find(filter => filter.Member === filterMember && filter.Condition === UserFilterQueryCondition);
    }

    const queryFilter = GetQueryFilter(query) || { Values: [] };

    const [values, setValues] = React.useState<string[]>(queryFilter.Values as string[]);

    const [allUsers, setAllUsers] = React.useState<User[]>(null);
    const legacyClient = useWebPortalLegacyClient();

    React.useEffect(() => {
        legacyClient.getUsersUnrestricted({}).then(users => {
            setAllUsers(users.Data);
        });
    }, []);

    return (<MultiSelectModal header={UserHeader + ' Filter'}
        isLoading={!allUsers}
        show={true}
        options={allUsers}
        valueKey={UserNameKey}
        labelKey={UserNameKey}
        values={values}
        onChange={(updatedValues) => {
            setValues(updatedValues.length > 0 ? updatedValues.map(v => v[UserNameKey]) : null);
        }}
        onApply={() => {
            onApply(filterMember, UserFilterQueryCondition, values);
        }}
        onClear={() => {
            onApply(filterMember, UserFilterQueryCondition, []);
        }}
        onClose={onClose}
    />)
}

export default UserFilterModal;
